import { render } from "./RatingInput.vue?vue&type=template&id=fc7d300c&scoped=true"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"

import "./RatingInput.vue?vue&type=style&index=0&id=fc7d300c&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7d300c"]])

export default __exports__